<template>
    <div class="request-form-container">
        <div class="propHeader">Name: {{ getContainerVal(container.containerName) }}</div>
        <div class="propHeader">Downhole: {{ getContainerVal(container['Downhole LSD']) }}</div>
        <div class="propHeader">Device: {{ getContainerVal(container['serialnum']) }}</div>
        <div class="propHeader">Volume: {{ getContainerVal(container['Volume (%)']) }}% / {{
            getContainerVal(container['Volume (L)']) }}L / {{ getContainerVal(container['Volume (cm)']) }}cm</div>
        <div class="propHeader">Product: {{ getContainerVal(container['Product']) }}</div>
        <hr />

        <div class="propHeader" v-if="selectedRequest === 'calibration'">
            <DxTextBox id="level" label="Level Height (cm)" @value-changed="infoChanged" />
        </div>
        <div class="propHeader" v-if="selectedRequest === 'calibration'">
            <DxDateBox id="levelDate" label="Date/Time" type="datetime" :max="Date.now()"
                @value-changed="infoChanged" />
        </div>
        <div class="propHeader" v-if="selectedRequest === 'product'">
            <DxTextBox id="product" label="New product" @value-changed="infoChanged" />
        </div>
        <div class="propHeader" v-if="selectedRequest === 'tank'">
            <DxTextBox id="name" label="New Tank Name" @value-changed="infoChanged" />
        </div>
        <div class="propHeader" v-if="selectedRequest === 'tank'">
            <DxTextBox id="downhole" label="New Downhole LSD" @value-changed="infoChanged" />
        </div>
        <div class="propHeader" v-if="selectedRequest === 'tank'">
            <DxTextBox id="capacity" label="New Capacity" @value-changed="infoChanged" />
        </div>

        <hr />
        <div class="buttons">
            <DxButton class="saveBtn" :disabled="!canSubmit" icon="email" text="Send" @click="handleSubmit" />
            <DxButton class="cancelBtn" text="Cancel" @click="handleCancel" />
        </div>
    </div>
</template>

<script>
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import DxDateBox from 'devextreme-vue/date-box';

export default {
    name: 'ContainerRequestForm',
    components: {
        DxButton,
        DxTextBox,
        DxDateBox,
    },
    props: {
        container: {
            type: Object,
            required: true
        },
        selectedRequest: {
            type: String,
            required: true
        }
    },
    emits: ['request-submitted', 'request-cancelled'],
    data() {
        return {
            reqLevel: "",
            reqLevelDate: "",
            reqProduct: "",
            reqName: "",
            reqDownhole: "",
            reqCapacity: "",
        };
    },
    computed: {
        canSubmit() {
            if (this.selectedRequest === "calibration"
                && this.reqLevel !== ""
                && this.reqLevelDate !== "")
                return true;

            if (this.selectedRequest === "product"
                && this.reqProduct.length > 1)
                return true;

            if (this.selectedRequest === "tank"
                && (this.reqName !== ""
                    || this.reqDownhole !== ""
                    || this.reqCapacity !== ""))
                return true;

            return false;
        }
    },
    methods: {
        getContainerVal(propVal) {
            if (propVal !== undefined && propVal !== null && propVal !== '') {
                return propVal;
            }
            return '-';
        },
        handleSubmit() {
            const request = {
                containerId: this.container.containerId,
                containerName: this.container.containerName,
                requestType: this.selectedRequest,
                requestInfo: this.getAllRequestInfo()
                
            };

            this.$emit('request-submitted', request);
            this.resetAllRequestInfo();
        },
        handleCancel() {
            this.resetAllRequestInfo();
            this.$emit('request-cancelled');
        },
        resetAllRequestInfo() {
            this.reqLevel = "";
            this.reqLevelDate = "";
            this.reqProduct = "";
            this.reqName = "";
            this.reqDownhole = "";
            this.reqCapacity = "";
        },
        getAllRequestInfo() {
            return this.reqLevel + this.reqLevelDate + this.reqProduct + this.reqName + this.reqDownhole + this.reqCapacity;
        },
        infoChanged(e) {
            if (e.element.id === 'level')
                this.reqLevel = "<br>Level: " + e.value;
            else if (e.element.id === 'levelDate')
                this.reqLevelDate = "<br>Level Date: " + e.value;
            else if (e.element.id === 'product')
                this.reqProduct = "<br>Product: " + e.value;
            else if (e.element.id === 'name')
                this.reqName = "<br>Name: " + e.value;
            else if (e.element.id === 'downhole')
                this.reqDownhole = "<br>Downhole: " + e.value;
            else if (e.element.id === 'capacity')
                this.reqCapacity = "<br>Capacity: " + e.value;
        },
    },
};
</script>

<style scoped>
.request-form-container {
    width: 100%;
}

.propHeader {
    font-size: 16px;
    font-weight: 300;
    color: rgb(255, 255, 255, .7);
    margin-bottom: 6px;
    z-index: 20;
}

hr {
    height: 1px;
    border: 1px solid #444;
}

.buttons {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 15px;
}

.saveBtn {
    color: black;
    background-color: #ff7300;
    width: 100px;
}

.cancelBtn {
    color: black;
    background-color: rgb(255, 255, 255, 0.3);
    width: 100px;
}
</style>
